//
export default [
    {
        text: "#",
        value: "id",
    },
    {
        text: "responsable",
        value: "g_originator_user_full_name",
    },
    {
        text: "orden de compra",
        value: "pch_purchase_order_id",
        component: {
            type: 'link',
            props: {
                mapper: value => ({
                    name: 'purchase-order-update',
                    params: {
                        id: value,
                    },
                }),
                tooltip: 'Detalle orden de compra',
            },
        },
    },
    {
        text: "fecha de creación",
        value: "created_at",
        format: "datetime",
        align: "right",
    },
    {
        text: "fecha de autorización",
        value: "authorization_date",
        format: "datetime",
        align: "right",
    },
    {
        text: "estado",
        value: "pch_purchase_order_state_name",
        align: "center",
        component: {
            type: "chip",
            props: {
                disabled: true,
                label: true,
                small: true,
                textColor: "black",
            }
        },
    },
    {
        text: "total neto",
        value: "pch_selected_purchase_orders_net_price",
        format: "currency",
        align: "right",
    },
]